import type { ProductCode } from 'tio-reporting/utils/dataset-utils';

export interface CompanyProductSignals {
  taEnabled: boolean | null | undefined;
  pslfEnabled: boolean | null | undefined;
  syfEnabled: boolean | null | undefined;
  /** A non-wellness plan is what makes a company an SLR company; wellness-only plans do not. */
  hasRepaymentPlan: boolean;
}

/** Licensed reporting products, from the same switches as the admin "Products & Eligibility" grid; Core is implied. */
export function companyReportProducts(signals: CompanyProductSignals): ProductCode[] {
  const products: ProductCode[] = [];
  if (signals.taEnabled) products.push('TAS');
  if (signals.pslfEnabled) products.push('PSLF');
  if (signals.hasRepaymentPlan) products.push('SLR');
  if (signals.syfEnabled) products.push('SYF');
  return products;
}
